import React from "react";
import cs from "classnames";

import { InformationBox } from "../InformationBox/InformationBox";
import { UserViewType } from "../UserViewType/UserViewType";

import "./StructureHeader.scss";

interface Props {
  title: string;
  hideBorder?: boolean;
  message?: string | undefined;
  description?: React.ReactNode;
  showUserViewType?: boolean;
  userViewType?: string;
}

export const StructureHeader = ({
  title,
  hideBorder,
  message,
  description,
  showUserViewType,
  userViewType,
}: Props) => {
  return (
    <div className="StructureHeader">
      <div
        className={cs("StructureHeader__title", {
          "StructureHeader__title--with-description": !!description,
        })}
      >
        <div className="StructureHeader__titleRow">
          <h1>{title}</h1>
          {message && <InformationBox message={message} />}
          {showUserViewType && <UserViewType type={userViewType} />}
        </div>
        {description && (
          <div className="StructureHeader__description">{description}</div>
        )}
      </div>
    </div>
  );
};
